import {
  FormControl,
  FormHelperText,
  FormLabel,
  InputLabel,
} from '@material-ui/core';
import { FieldHookConfig, useField } from 'formik';
import { RichTextEditor, RichTextEditorProps } from '../RichTextEditor';
import { IFieldProps } from './FormRender/IFormFieldSetting';
import { FormControlProps } from './FormControls/FormControl';
import React from 'react';
import clsx from 'clsx';

export const FormRichTextField = ({
  onChange,
  onBlur,
  value,
  hasMentions,
  onChangeMentions,
  autoFocus,
  additionalButtons,
  isInvoiceTemplateEditor,
  extendedMode,
  labelOnTop,
  ...props
}: FieldHookConfig<string> &
  IFieldProps &
  Omit<RichTextEditorProps, 'onChange'>) => {
  const [field, meta, helpers] = useField<string>({ ...props });
  const handleChange = (value: string | undefined | null) => {
    // formik is not happy with neither undefined nor null
    const formikValue = value ?? '';
    field.onChange(formikValue);
    helpers.setValue(formikValue, true);
    onChange?.(value);
  };
  return (
    <RichTextField
      className={props.className}
      fullWidth={props.fullWidth !== false}
      disabled={props.disabled}
      variant="outlined"
      label={props.label}
      error={meta.error}
      info={props.info}
      helperText={props.helperText}
      value={field.value}
      onChange={handleChange}
      hasMentions={hasMentions}
      onChangeMentions={onChangeMentions}
      autofocus={autoFocus}
      additionalButtons={additionalButtons}
      isInvoiceTemplateEditor={isInvoiceTemplateEditor}
      extendedMode={extendedMode}
      labelOnTop={labelOnTop}
      {...props}
    />
  );
};
export interface RichTextFieldProps
  extends RichTextEditorProps,
    Pick<FormControlProps, 'className' | 'fullWidth' | 'variant'> {
  error?: string;
  label?: string;
  info?: string;

  helperText?: string;
}
export function RichTextField({
  className,
  error,
  fullWidth,
  disabled,
  label,
  info,
  variant = 'outlined',
  helperText,
  labelOnTop,
  ...props
}: RichTextFieldProps) {
  const [controlsVisible, setControlsVisible] = React.useState<boolean>(false);
  return (
    <>
      <FormControl
        className={className}
        error={Boolean(error)}
        fullWidth={fullWidth !== false}
        disabled={disabled}
        variant={variant}
      >
        {label && (
          <>
            {labelOnTop ? (
              <FormLabel
                error={Boolean(error)}
                className={'rich-text-form-label'}
              >
                {label}
              </FormLabel>
            ) : (
              <InputLabel
                error={Boolean(error)}
                className={clsx('rich-text-input-label', {
                  'rich-text-input-label-focused': controlsVisible,
                })}
                variant="filled"
              >
                {label}
              </InputLabel>
            )}
          </>
        )}

        <RichTextEditor
          info={info}
          setControlsVisible={setControlsVisible}
          labelOnTop={labelOnTop}
          {...props}
        />
        {error !== undefined ||
          (!!helperText && (
            <FormHelperText error={Boolean(error)}>
              {error || helperText}
            </FormHelperText>
          ))}
      </FormControl>
    </>
  );
}
